const CenterImg = () => {
  return (
    <svg
      focusable="false"
      aria-hidden="true"
      height="32"
      width="32"
      fill="none"
    >
      <g>
        <rect width="32" height="32" rx="4"></rect>
      </g>
      <circle cx="22" cy="10" r="2" fill="#333"></circle>
      <circle cx="11" cy="10" r="2" fill="#333"></circle>
      <circle cx="11" cy="21" r="2" fill="#333"></circle>
      <circle cx="22" cy="21" r="2" fill="#333"></circle>
    </svg>
  );
};

export default CenterImg;
